import { JSEncrypt } from "jsencrypt";

const win: any = window
export function encrypt(message: any) {
  const publicKey = win.PK;
  let RSAEncrypt = new JSEncrypt();
  RSAEncrypt.setPublicKey(publicKey);
  let encryptedMessage = RSAEncrypt.encrypt(message);
  console.log(message, 'message', encryptedMessage, publicKey)

  return encryptedMessage;
}

const createTransactionID = (isCorrelationId = false) => {
  let currentDateTime = new Date()
      .toISOString()
      .replace(/-|:|T/gi, '')
      .replace('.', '')
      .slice(2)
      .slice(0, -1)
  return (
      'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000)
  )
}
export { createTransactionID };